export const createFileFlag = (api, payload) => api.rpc('service-upload', '2/2020-08-25/create_file_flag', payload);
